import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';

const HomePage: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  if (!user) {
    return (
      <div style={{ maxWidth: 800, margin: 'auto', padding: 32, textAlign: 'center' }}>
        <h1>{t('welcome_to_vaultal')}</h1>
        <p>{t('secure_2fa_authenticator')}</p>
        
        <div style={{ marginTop: 32 }}>
          <Link to="/login" style={{ 
            marginRight: 16, 
            padding: '12px 24px', 
            backgroundColor: '#007bff', 
            color: 'white', 
            textDecoration: 'none', 
            borderRadius: 4 
          }}>
            {t('login')}
          </Link>
          <Link to="/register" style={{ 
            padding: '12px 24px', 
            backgroundColor: '#28a745', 
            color: 'white', 
            textDecoration: 'none', 
            borderRadius: 4 
          }}>
            {t('register')}
          </Link>
        </div>

        <div style={{ marginTop: 48, textAlign: 'left' }}>
          <h2>{t('features')}:</h2>
          <ul>
            <li>{t('secure_totp_generation')}</li>
            <li>{t('local_encryption')}</li>
            <li>{t('qr_code_scanning')}</li>
            <li>{t('multi_language_support')}</li>
            <li>{t('cross_platform')}</li>
          </ul>
        </div>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 800, margin: 'auto', padding: 32 }}>
      <h1>{t('welcome_back')}, {user.email}!</h1>
      
      <div style={{ 
        background: '#f8f9fa', 
        padding: 24, 
        borderRadius: 8, 
        marginBottom: 32 
      }}>
        <h2>{t('your_account')}</h2>
        <p><strong>{t('plan')}:</strong> {t(user.role)}</p>
        <p><strong>{t('email')}:</strong> {user.email}</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 24 }}>
        <div style={{ 
          border: '1px solid #ddd', 
          padding: 20, 
          borderRadius: 8,
          textAlign: 'center'
        }}>
          <h3>{t('totp_codes')}</h3>
          <p>{t('manage_your_2fa_codes')}</p>
          <Link to="/totp" style={{ 
            display: 'inline-block',
            padding: '8px 16px', 
            backgroundColor: '#007bff', 
            color: 'white', 
            textDecoration: 'none', 
            borderRadius: 4 
          }}>
            {t('manage_codes')}
          </Link>
        </div>

        <div style={{ 
          border: '1px solid #ddd', 
          padding: 20, 
          borderRadius: 8,
          textAlign: 'center'
        }}>
          <h3>{t('profile')}</h3>
          <p>{t('update_your_profile')}</p>
          <Link to="/profile" style={{ 
            display: 'inline-block',
            padding: '8px 16px', 
            backgroundColor: '#28a745', 
            color: 'white', 
            textDecoration: 'none', 
            borderRadius: 4 
          }}>
            {t('edit_profile')}
          </Link>
        </div>

        {(user.role === 'premium' || user.role === 'admin') && (
          <div style={{ 
            border: '1px solid #ddd', 
            padding: 20, 
            borderRadius: 8,
            textAlign: 'center'
          }}>
            <h3>{t('sync')}</h3>
            <p>{t('sync_across_devices')}</p>
            <Link to="/sync" style={{ 
              display: 'inline-block',
              padding: '8px 16px', 
              backgroundColor: '#ffc107', 
              color: 'black', 
              textDecoration: 'none', 
              borderRadius: 4 
            }}>
              {t('sync_now')}
            </Link>
          </div>
        )}

        {user.role === 'admin' && (
          <div style={{ 
            border: '1px solid #ddd', 
            padding: 20, 
            borderRadius: 8,
            textAlign: 'center'
          }}>
            <h3>{t('admin_panel')}</h3>
            <p>{t('manage_users_and_system')}</p>
            <Link to="/admin" style={{ 
              display: 'inline-block',
              padding: '8px 16px', 
              backgroundColor: '#dc3545', 
              color: 'white', 
              textDecoration: 'none', 
              borderRadius: 4 
            }}>
              {t('admin_access')}
            </Link>
          </div>
        )}
      </div>

      {user.role === 'free' && (
        <div style={{ 
          background: '#fff3cd', 
          border: '1px solid #ffeaa7', 
          padding: 20, 
          borderRadius: 8, 
          marginTop: 32,
          textAlign: 'center'
        }}>
          <h3>{t('upgrade_to_premium')}</h3>
          <p>{t('unlock_premium_features')}</p>
          <Link to="/upgrade" style={{ 
            display: 'inline-block',
            padding: '12px 24px', 
            backgroundColor: '#007bff', 
            color: 'white', 
            textDecoration: 'none', 
            borderRadius: 4 
          }}>
            {t('upgrade_now')}
          </Link>
        </div>
      )}
    </div>
  );
};

export default HomePage; 